import train from '../images/train.png';
import ip_tracker from '../images/ip-tracker.png';
import weather from '../images/weatherApp.png';
import dictionary from '../images/dictionary.png';
import thrifty from '../images/thrifty.png';
import social from '../images/social.png';

export interface Project {
  img: string;
  link: string;
  title: string;
}

export const projects: Project[] = [
  {
    img: thrifty,
    link: 'https://thrifty-kohl.vercel.app',
    title: 'Thrifty',
  },
  {
    img: weather,
    link: 'https://anastafish.github.io/weather-app/',
    title: 'WeatherApp',
  },
  {
    img: social,
    link: 'https://social-media-app-fslc.vercel.app/',
    title: 'Social Media App',
  },
  {
    img: ip_tracker,
    link: 'https://anastafish.github.io/IP-Address-Tracker/',
    title: 'Ip Tracker',
  },
  {
    img: train,
    link: 'https://anastafish.github.io/Reactive-Train/',
    title: 'Train Ticket App',
  },
  {
    img: dictionary,
    link: 'https://anastafish.github.io/dictionary-app/',
    title: 'Dictionary',
  },
];


